import React from 'react';
import { Pill, Globe, Zap, CheckCircle, Rocket } from 'lucide-react';
interface InfoSectionProps {
  icon: 'flask' | 'pill' | 'globe' | 'zap' | 'check-circle' | 'rocket';
  title: string;
  content: string | string[];
}
const InfoSection: React.FC<InfoSectionProps> = ({
  icon,
  title,
  content
}) => {
  const renderIcon = () => {
    switch (icon) {
      case 'flask':
        return <div size={32} className="text-teal-600" data-id="element-134" data-mp="36cnjbrsy6308" />;
      case 'pill':
        return <Pill size={32} className="text-teal-600" data-id="element-135" data-mp="36akjyh5wmxiu" />;
      case 'globe':
        return <Globe size={32} className="text-teal-600" data-id="element-136" data-mp="3bb8c565vdken" />;
      case 'zap':
        return <Zap size={32} className="text-teal-600" data-id="element-137" data-mp="2wdfxshc27221" />;
      case 'check-circle':
        return <CheckCircle size={32} className="text-teal-600" data-id="element-138" data-mp="31d14xf1dugpu" />;
      case 'rocket':
        return <Rocket size={32} className="text-teal-600" data-id="element-139" data-mp="1kzkgp31lgj86" />;
      default:
        return <div size={32} className="text-teal-600" data-id="element-140" data-mp="1l1nggesjtqq3" />;
    }
  };
  const renderContent = () => {
    if (typeof content === 'string') {
      return <p className="text-gray-600 leading-relaxed" data-id="element-141" data-mp="1vdrf472dq006">{content}</p>;
    } else if (Array.isArray(content)) {
      return <ul className="text-gray-600 leading-relaxed space-y-3" data-id="element-142" data-mp="1qgriemrf69lq">
          {content.map((item, index) => <li key={index} className="flex items-start" data-id="element-143" data-mp="24gsk24fidl29" data-mpi={index}>
              <div className="mr-3 mt-1 text-teal-500 flex-shrink-0" data-id="element-144" data-mp="1zfmps2679pqm">
                <CheckCircle size={18} data-id="element-145" data-mp="1zih7vn1qqygv" />
              </div>
              <span data-id="element-146" data-mp="2ec3yeln08q9h">{item}</span>
            </li>)}
        </ul>;
    }
  };
  return <div id={title.toLowerCase().replace(/\s+/g, '-')} className="mb-16 group hover:transform hover:scale-[1.01] transition-all duration-300" data-id="element-147" data-mp="29diwmhs3tyix">
      <div className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100" data-id="element-148" data-mp="2j3lq0j351ehs">
        <div className="flex items-center mb-6 gap-4" data-id="element-149" data-mp="2x4oet3lip2we">
          <div className="p-4 bg-teal-100 rounded-xl group-hover:bg-teal-200 transition-colors duration-300 shadow-sm" data-id="element-150" data-mp="2s4tqn7t4mrf1">
            {renderIcon()}
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-teal-800" data-id="element-151" data-mp="1pt8jhwk1yz90">
            {title}
          </h2>
        </div>
        <div className="ml-0" data-id="element-152" data-mp="1tqmplfcfsqws">{renderContent()}</div>
      </div>
    </div>;
};
export default InfoSection;